export const ROLES = {
  ADMIN: "admin",
  REQUESTER: "requester",
  APPROVER: "approver",
  FINANCE: "finance",
  STORES: "stores",
};
